import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        upload_url: process.env.VUE_APP_BASE_URL + '/api/veteran/vs/pension/upload',
        upload_excel: process.env.VUE_APP_BASE_URL + '/api/veteran/vs/order/offer/import',
        upload_avatar: process.env.VUE_APP_BASE_URL + '/api/veteran/vs/common/upload',
        download_excel: process.env.VUE_APP_BASE_URL + '/upload/common/family_info_template.xlsx',
        userInfo: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : {},
        upload_avatar_url: process.env.VUE_APP_BASE_URL + '/api/veteran/user/avatar?url=',
        upload_file: process.env.VUE_APP_BASE_URL + '/api/veteran/vs/common/upload'
    },
    getters: {
        userInfo: state => {
            if (!state.userInfo) {
                state.userInfo = JSON.parse(localStorage.getItem('userInfo'))
            }
            return state.userInfo
        }
    },
    mutations: {
        setUserInfo(state, data) {
            Object.assign(state.userInfo, data)
            localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
        }
    },
    actions: {
        setUserInfo(context) {
            context.commit('setUserInfo')
        }
    }
})